import { Basket } from '@/models/Basket';
import { setLastSelectedCity } from './LocalStorage';
import { getCities, getDistricts } from './SettingsStorage';

export function syncSiteDistrictFromDistrictId(districtId?: number | null) {
  if (!districtId) return;
  const district = getDistricts().find((item) => item.id === districtId);
  if (!district) return;
  const city = getCities().find((item) => item.id === district.cityId);
  setLastSelectedCity(city, district);
}

export function syncSiteDistrictFromBasket(basket?: Basket) {
  if (!basket?.district?.id) return;
  syncSiteDistrictFromDistrictId(basket.district.id);
}
